import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const forWho = ["Women who feel 'wired' but exhausted every single night.", "Professionals and high-performers who can't afford to have 'brain fog.'", "Anyone experiencing 'Mom Rage' or sudden irritability from sensory overload.", 'Women noticing stubborn midsection weight gain despite eating well.'];
  const notForWho = ["People looking for a 'magic pill' or pharmaceutical prescription.", 'Those unwilling to spend 4 minutes a day on physical resets.', "Anyone currently under medical treatment for clinical Addison's or Cushing's disease (without consulting their doctor)."];
  return <section className="bg-navy-900 text-cream-100 py-24 px-6" data-id="element-171">
      <div className="container mx-auto max-w-6xl" data-id="element-172">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-173">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-800/50 border border-gold-500/20 rounded-2xl p-8 md:p-10 backdrop-blur-sm" data-id="element-174">
            <h3 className="font-serif text-3xl text-cream-50 mb-8 border-b border-gold-500/20 pb-4 flex items-center gap-3" data-id="element-175">
              <CheckCircle2 className="text-green-400" size={32} data-id="element-176" />
              This Is For You If...
            </h3>
            <ul className="space-y-6" data-id="element-177">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4 text-cream-200" data-id="element-178">
                  <div className="bg-green-400/10 p-1 rounded-full text-green-400 shrink-0 mt-1" data-id="element-179">
                    <CheckCircle2 size={16} data-id="element-180" />
                  </div>
                  <span className="text-lg leading-relaxed" data-id="element-181">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-800/30 border border-navy-700 rounded-2xl p-8 md:p-10" data-id="element-182">
            <h3 className="font-serif text-3xl text-cream-300 mb-8 border-b border-navy-700 pb-4 flex items-center gap-3" data-id="element-183">
              <XCircle className="text-red-400/70" size={32} data-id="element-184" />
              This Is NOT For You If...
            </h3>
            <ul className="space-y-6" data-id="element-185">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4 text-cream-400/80" data-id="element-186">
                  <div className="bg-red-400/10 p-1 rounded-full text-red-400/70 shrink-0 mt-1" data-id="element-187">
                    <XCircle size={16} data-id="element-188" />
                  </div>
                  <span className="text-lg leading-relaxed" data-id="element-189">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}